import { pipelineStages } from '@/data/stageConfig';
import { isForkHireGlobalCandidateVisible } from '@/lib/forkhire/workflow/globalCandidateVisibility';

export const CANONICAL_DISQUALIFIED_STAGE = 'rejected';
export const CANONICAL_DISQUALIFIED_STATUS = 'rejected';

export const DISQUALIFY_COPY = {
  actionLabel: 'Disqualify',
  title: 'Disqualify candidate?',
  body: 'This will remove the candidate from the active hiring pipeline for this job.',
  confirmLabel: 'Disqualify',
  cancelLabel: 'Cancel',
};

const activeDisqualifiableStages = new Set<string>([
  ...pipelineStages,
  'reviewed',
  'shortlisting',
  'interview_invited',
  'ai_interview_completed',
  'f2f_interview',
]);

const terminalStages = new Set<string>([
  CANONICAL_DISQUALIFIED_STAGE,
  'withdrawn',
  'archived',
  'hired',
]);

export function canDisqualifyCandidate(stage: string | null | undefined) {
  if (!stage || terminalStages.has(stage)) return false;
  return activeDisqualifiableStages.has(stage);
}

export function buildDisqualifyStageMutation(applicationId: string) {
  return {
    applicationId,
    stage: CANONICAL_DISQUALIFIED_STAGE,
    status: CANONICAL_DISQUALIFIED_STATUS,
  };
}

export function isRemovedFromGlobalCandidatesAfterDisqualification() {
  return !isForkHireGlobalCandidateVisible({
    stage: CANONICAL_DISQUALIFIED_STAGE,
    status: CANONICAL_DISQUALIFIED_STATUS,
  });
}
